/* LP02 — advertorial (listicle).
   Em 27/08/2026 esta section deixou de ter caixa de compra: galeria,
   before/after, reels, abas de review e dock foram para assets/beneo-pdp.js
   junto com o corpo de venda. Aqui ficou o que o listicle usa de verdade. */

/* A barra fixa do topo (#sticky) foi removida do markup em 27/08/2026, junto
   com a topbar de brindes: as duas anunciavam a oferta num advertorial que nao
   vende. O controle de scroll que vivia aqui saiu junto — sem o elemento, era
   codigo que so procurava um id inexistente a cada scroll. */

(function(){
  var vs=[].slice.call(document.querySelectorAll('video.gif'));
  if(!vs.length) return;
  // toca so quando entra na tela: comportamento de GIF, sem baixar a pagina inteira de uma vez
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){
      var v=e.target;
      if(e.isIntersecting){ if(v.readyState<2) v.load(); v.play().catch(function(){}); }
      else v.pause();
    });
  },{threshold:.25});
  vs.forEach(function(v){ v.muted=true; io.observe(v); });
})();
